<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{ (formData?.subject || emailData?.subject || title) | titlecase }}
  </h4>
  <button type="button" (click)="close()" class="btn-close close pull-right">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body" [ngSwitch]="mode">
  <!-- <div [hidden]="iframeLoad" style="width: 100%" *ngSwitchCase="'PDF'">
    <iframe *ngIf="
        formData?.config?.is_pdf && formData?.config?.is_preview && pdf_url
      " [src]="pdf_url | safeHtml : 'URL'" style="width: 100%; height: 600px"></iframe>
  </div> -->
  <ng-container *ngSwitchDefault>
    <div class="row" *ngIf="type !== 'SEND'">
      <div class="detail-header col-6">
        <table class="table table-custom2">
          <tbody>
            <tr>
              <th>To:</th>
              <td>{{ emailData?.receiver }}</td>
            </tr>
            <ng-container *ngIf="mode === 'EMAIL'">
              <tr>
                <th>CC:</th>
                <td>{{ emailData?.cc }}</td>
              </tr>
              <tr>
                <th>BCC:</th>
                <td>{{ emailData?.bcc }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div *ngIf="emailData?.message" class="mail-cnt px-2" style="max-width: fit-content"
        [innerHTML]="emailData?.message | safeHtml"></div>

      <!-- attachment_path or attachment -->
      <div *ngIf="emailData?.attachment_path || emailData?.attachment" class="px-4">
        <app-image-upload class="align-right cursor-pointer" #imageUploader 
          [inputFile]="emailData?.attachment_path || emailData?.attachment"
          [multiple]="true"
          [disabled]="true"></app-image-upload>
      </div>
    </div>

    <!-- <ng-container *ngIf="!emailData"> -->
    <ng-container *ngIf="type == 'SEND'">
      <div class="detail-header col-6 mb-1">
        <table class="table table-custom2">
          <tbody>
            <tr>
              <th>To:</th>
              <td>{{ emailData?.receiver }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12" *ngIf="mode === 'EMAIL'">
        <app-form-generator #basicForm (onChangeEvent)="onChange($event)"
          [formData]="BASIC_FORM_BUILDER"></app-form-generator>
      </div>
      <div class="col-12" [hidden]="formData?.config?.is_pdf && formData?.config?.is_preview">
        <label>Body</label>
      </div>
      <div class="col-12 mb-2">
        <div class="border" style="min-height: 5rem" (blur)="onChangeContent($event)"
          [hidden]="formData?.config?.is_pdf && formData?.config?.is_preview" [innerHTML]="formData?.body | safeHtml"
          contenteditable="true"></div>
      </div>
      <div class="col-12" *ngIf="mode == 'EMAIL'">
        <app-form-doc #docForm [config]="{
            title: 'Attachment',
            hideRemark: true,
            fileTitle: 'Attachment'
          }" [mode]="'EDIT'"></app-form-doc>
      </div>
    </ng-container>
  </ng-container>

  <div *ngIf="dataLoading || iframeLoad" class="fetching mt20 mb20 col-lg-12 col-md-12 col-sm-12"
    style="text-align: center">
    <i class="pi pi-spin pi-spinner"></i>
    please wait.. getting data...
  </div>
</div>
<div class="row clearfix text-center m-5">
  <div class="col-12">
    <ng-container *ngIf="sentBtnShow">
      <button [disabled]="loading" (click)="send()" class="btn btn-round btn-success">
        <i *ngIf="loading" class="pi pi-spin pi-spinner"></i>Send
      </button>
    </ng-container>
    <button (click)="close()" class="btn ml-1 btn-round btn-warning">
      {{ isModal ? "Close" : "Back" }}
    </button>
  </div>
</div>